import request from '@/utils/request'

export function getHeadData() {
  return request({
    url: '/index/index/getHeadData',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}

export function getLastedArticles() {
  return request({
    url: '/index/index/getLastedArticles',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}

export function getContent(query) {
  return request({
    url: '/index/index/getContent',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getReportDownloadsPage(query) {
  return request({
    url: '/index/index/getReportDownloadsPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getCorrelationMenu() {
  return request({
    url: '/index/index/getCorrelationMenu',
    headers: {
      // isToken: false
    },
    method: 'post'
  })
}

export function calcuCorrelation(query) {
  return request({
    url: '/index/index/calcuCorrelation',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryCollege(query) {
  return request({
    url: '/index/index/queryCollege',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryProvince(query) {
  return request({
    url: '/index/index/queryProvince',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getPublishData(query) {
  return request({
    url: '/index/index/getPublishData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportReport(query) {
  return request({
    url: '/index/index/exportReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function prepareToDownload(query) {
  return request({
    url: '/index/index/prepareToDownload',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryPayResult(query) {
  return request({
    url: '/index/pay/queryPayResult',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function toPay(query) {
  return request({
    url: '/index/index/toPay',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryCollegeRank(query) {
  return request({
    url: '/index/index/queryCollegeRank',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}

export function commitInvoice(query) {
  return request({
    url: '/index/index/commitInvoice',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}
